import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=beea0baa&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=beea0baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beea0baa",
  null
  
)

export default component.exports